import {Controller, useFormContext} from 'react-hook-form';
import {useTranslation} from 'react-i18next';
import {AgreementClause} from '@chekin/core';
import {Checkbox} from '@chekinapp/ui';
import {getAgreementClausesData} from './getAgreementClausesData';
import {FieldsGroup} from '../ui/FieldsGroup';
import {Label} from './Label';

export const AgreementClausesKeyFormName = 'agreement_clauses';

type FormTypes = Record<string, boolean>;

type Props = {
  clauses?: AgreementClause[];
};

const AgreementClausesItems = ({clauses}: Props) => {
  const {control} = useFormContext<FormTypes>();
  const agreementClausesItems =
    clauses?.filter(clause => clause.is_active).map(getAgreementClausesData) || [];

  if (!agreementClausesItems.length) {
    return null;
  }

  return (
    <>
      {agreementClausesItems.map(({name, body, required}) => (
        <div
          key={name}
          className="[&_.error-message]:static [&_.error-message]:ml-[35px]"
        >
          <Controller
            name={`${AgreementClausesKeyFormName}.${name}`}
            control={control}
            rules={{required}}
            render={({field, fieldState: {error}}) => (
              <Checkbox
                label={<Label body={body} required={required} />}
                className="agreement-checkbox items-start"
                labelClassName="!text-[14px] !font-normal"
                error={error?.message}
                {...field}
              />
            )}
          />
        </div>
      ))}
    </>
  );
};

const AgreementClausesBox = ({clauses}: Props) => {
  const {t} = useTranslation();
  const hasActiveClauses = Boolean(clauses?.some(clause => clause.is_active));

  if (!hasActiveClauses) {
    return null;
  }

  return (
    <FieldsGroup title={t('agreements')} centered={false} groupName="clauses">
      <AgreementClausesItems clauses={clauses} />
    </FieldsGroup>
  );
};

export {AgreementClausesBox, AgreementClausesItems};
